"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNUP_PRE_INTENT_EVENT = exports.SIGNUP_CONVERSION_EVENT = exports.TRIGGER_SCROLL_TRACKING = exports.SIGNUP_INTENT_EVENT = exports.ClickIds = void 0;
var ClickIds;
(function (ClickIds) {
    ClickIds["Facebook"] = "fbclid";
    ClickIds["Google"] = "gclid";
    ClickIds["Bing"] = "msclkid";
})(ClickIds = exports.ClickIds || (exports.ClickIds = {}));
var TrackingConstants = {
    CLICK_ID_COOKIE_EXPIRATION: 60 * 60 * 24 * 5,
    UTM_COOKIE_EXPIRATION: 60 * 60 * 24 * 5,
    UTM_COOKIE_NAME: '__utm_params',
    UTM_PARAM_NAMES: [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
    ],
}; // Triggered when the user attempts to sign-up. May fire more than once as the user interacts with the form(s).
exports.SIGNUP_INTENT_EVENT = 'auth: signup_intent'; // Triggered when the user successfully completes the sign up process.
exports.TRIGGER_SCROLL_TRACKING = 'ScrollDistance'; // Triggers scroll tracking via GTM tag
exports.SIGNUP_CONVERSION_EVENT = 'auth: signup'; // Triggered when a user clicks the `Sign Up` button in the header
exports.SIGNUP_PRE_INTENT_EVENT = 'auth: signup_pre_intent';
exports.default = TrackingConstants;
